import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { clipLineSegmentPoly } from "@thi.ng/geom-clip-line";
import { sutherlandHodgeman } from "@thi.ng/geom-clip-poly";
import { centroid } from "@thi.ng/geom-poly-utils";
import { Group } from "../api/group";
import { Line } from "../api/line";
import { Polygon } from "../api/polygon";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
import { ensureVertices, vertices } from "./vertices";
export const clipConvex = defmulti(dispatch);
clipConvex.addAll({
    [Type.GROUP]: ({ children, attribs }, boundary) => {
        boundary = ensureVertices(boundary);
        const clipped = [];
        for (let c of children) {
            const res = clipConvex(c, boundary);
            if (res)
                clipped.push(res);
        }
        return new Group(Object.assign({}, attribs), clipped);
    },
    [Type.LINE]: ($, boundary) => {
        const segments = clipLineSegmentPoly($.points[0], $.points[1], ensureVertices(boundary));
        return segments && segments.length
            ? new Line(segments[0], copyAttribs($))
            : undefined;
    },
    [Type.POLYGON]: ($, boundary) => {
        boundary = ensureVertices(boundary);
        const pts = sutherlandHodgeman($.points, boundary, centroid(boundary));
        return pts.length ? new Polygon(pts, copyAttribs($)) : undefined;
    },
    [Type.RECT]: ($, boundary) => {
        boundary = ensureVertices(boundary);
        const pts = sutherlandHodgeman(vertices($), boundary, centroid(boundary));
        return pts.length ? new Polygon(pts, copyAttribs($)) : undefined;
    },
});
clipConvex.isa(Type.CIRCLE, Type.RECT);
clipConvex.isa(Type.ELLIPSE, Type.RECT);
clipConvex.isa(Type.PATH, Type.RECT);
clipConvex.isa(Type.QUAD, Type.POLYGON);
clipConvex.isa(Type.TRIANGLE, Type.POLYGON);
